import { GetInterviewStepTypes } from "../../../actionTypes/interviewStepType";

export function getInterviewStepTypesAction() {
  return {
    type: GetInterviewStepTypes.REQUEST,
  };
}
